import React, { useState, useEffect } from 'react';

interface EasterEggProps {
  message: string;
  type: string;
  onClose: () => void;
}

const EasterEgg: React.FC<EasterEggProps> = ({ message, type, onClose }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Auto-close after 4 seconds
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(onClose, 300); // Wait for fade out animation
    }, 4000);

    return () => clearTimeout(timer);
  }, [onClose]);

  const handleClick = () => {
    setIsVisible(false);
    setTimeout(onClose, 300);
  };

  const getEasterEggClass = () => {
    const baseClass = 'easter-egg-modal';
    const typeClass = `easter-egg-${type}`;
    const visibilityClass = isVisible ? 'visible' : 'hidden';
    
    return `${baseClass} ${typeClass} ${visibilityClass}`;
  };

  const getEasterEggIcon = () => {
    switch (type) {
      case 'konami':
        return '🎮';
      case 'rapidClick':
        return '👆';
      case 'specialText':
        return '💖';
      case 'debugMode':
        return '🔧';
      case 'midnight':
        return '🌙';
      case 'christmas':
        return '🎄';
      case 'halloween':
        return '🎃';
      default:
        return '✨';
    }
  };

  return (
    <div className={getEasterEggClass()} onClick={handleClick}>
      <div className="easter-egg-content">
        <div className="easter-egg-icon">{getEasterEggIcon()}</div>
        <div className="easter-egg-message">{message}</div>
        <div className="easter-egg-close">Click to close</div>
      </div>
      <div className="easter-egg-particles">
        {Array.from({ length: 20 }).map((_, i) => (
          <div key={i} className="particle" />
        ))}
      </div>
    </div>
  );
};

export default EasterEgg; 